
import declare from	"dojo/_base/declare";
import lang from "dojo/_base/lang";
import _ from "underscore";
import Controller from "csi/action/Controller";
import Query from "csi/xml/Query";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from	"csi/xml";
import FormData from "csi/action/FormData";

const MassReplaceFormulatedProduct = declare([Controller, ActionControllerMixin], {

	/**
	 * @override
	 * Make sure that at least one is selected
	 */
	getFormData() {
		const fd = this.inherited<FormData>(arguments);
		fd.m_bRequireOne = true;
		fd.m_fAggregateTest = lang.hitch(this, this._canAggregatePlacement);
		return fd;
	},

	/**
	*@override
	* Prepare the data and pass it into the next page
	*/
	onNextPage(wizard, currentPage, nextPage, bFinish) {
		return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (wizard.getIndexOfPage(nextPage) == 1));
	},

	/**
	 * @override
	 * Create Query filter for second page (Index=1)
	 */
	getWizardViewQuery(wizard, view, index) {
		if (index == 1) {
			return new Query().Node(xml.PROP_FLAGS, xml.OP_BIT_0, xml.NODE_FLAG_FROZEN);
		}
		return null;
	},

	/**
	*@override
	* Refresh data in where used table
	*/
	postProcessSuccess() {
		this.widget.refreshData();
	},

	/**
	*@override
	* Only allow selection of nodes with Write access
	*/
	_canAggregatePlacement(ctx, fd) {
		return xml.nodeHasRight(ctx.getNode(), xml.RIGHT_WRITE);
	},
});

export = MassReplaceFormulatedProduct;
